import { REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS } from '../actions/requests_for_proposal_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import RFPPipelineFilters from '../components/requests_for_proposal_index_page/RFPPipelineFilters';
import { message } from 'antd';
import { logoutSuccess } from '../actions/session_actions';

export const requestsForProposalRestCrudThunksForBuyer = new RestCrudThunks(
	'requests_for_proposal',
	'request_for_proposal',
	'requestForProposal',
	'requestsForProposal',
	REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'quote/'
);
export const requestsForProposalRestCrudThunksForSupplier = new RestCrudThunks(
	'requests_for_proposal',
	'request_for_proposal',
	'requestForProposal',
	'requestsForProposal',
	REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'quote/'
);

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();
const getRFPStatusUrl = (roleType, status, eventId) =>
	`/api/v1/${roleType}/quote/requests_for_proposal/${status}/${eventId}`;

const requestForProposalStatusChange = (roleType) => (status, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(BASE_URL + getRFPStatusUrl(roleType, status, entity.id), {})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const requestForProposalStatusChangeForBuyer = requestForProposalStatusChange(
	ROLE_TYPES.BUYER
);
export const requestForProposalStatusChangeForSupplier = requestForProposalStatusChange(
	ROLE_TYPES.SUPPLIER
);

export const updateBidderStatus = (roleType) => (entity, status) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(BASE_URL + `/api/v1/${roleType}/quote/bidders/${entity.id}/${status}`, {})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const refreshRFPCount = (userType) => (filters) => (dispatch) => {
	const apiUrl = `/api/v1/${userType}/quote/requests_for_proposal/count_by_status`;

	const data = {
		...(filters || {}),
		statuses: RFPPipelineFilters.map((_) => _.name).join(','),
		status: undefined,
	};
	fetchUtils
		.get(
			BASE_URL + apiUrl,
			Object.assign(
				{
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				},
				data
			)
		)
		.then(parseJSON)
		.then(({ json, status, ok }) => {
			const d = json;
			if (d.status === 'error') {
				message.error(d.message);
			} else {
				if (d.data && d.data.length > 0) {
					d.data.map((category) =>
						dispatch(
							REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS.countBySuccess(
								category.count,
								category.categoryName
							)
						)
					);
				}
			}
		})
		.catch((d) => {
			message.error(d.message);
		});
};

export const downloadRFPCSV =
	(roleType) =>
	(params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/quote/requests_for_proposal/csv_report_generator`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};
